// Texte par défaut du bandeau de consentement diffusion. Volontairement sans
// mention des conséquences d'un refus : elles dépendent du réglage
// consentement_obligatoire et sont ajoutées côté diffusion.
export const PIXEL_META_TEXTE_BANDEAU_DEFAUT =
  "Avec votre accord, nous utilisons le Pixel Meta pour mesurer l'audience "
  + "et l'efficacité de nos campagnes.";

// Case d'opt-in prospection (non pré-cochée) affichée dans le bandeau quand la
// création de client Shopify est active. Consentement spécifique distinct du
// consentement de mesure, comme l'exige le RGPD pour la prospection.
export const PIXEL_META_TEXTE_OPTIN_SHOPIFY_DEFAUT =
  "J'accepte de recevoir par e-mail les offres et actualités de l'éditeur du jeu.";

export const COMMUNICATION_DIFFUSION_DEFAUTS = Object.freeze (
  {
    editeur_nom : '',
    logo_file_id : '',
    logo_url : '',
    creation_subject : 'Confirmez votre adresse e-mail',
    creation_html : '<p>Bonjour,</p><p>Confirmez votre adresse e-mail pour commencer à jouer.</p>',
    reconnexion_subject : 'Votre lien de connexion',
    reconnexion_html : '<p>Bonjour,</p><p>Confirmez votre reconnexion pour reprendre votre parcours.</p>',
    passwordless_sent_html : '<p>Merci, un e-mail vient vient de vous être envoyé avec un lien de connexion directe au jeu. Vous pouvez refermer cette fenêtre.</p>',
    welcome_html : '<p>Bienvenue !</p><p>Votre compte est prêt, vous pouvez commencer à jouer.</p>',
    header : {
      browser_bg_light : '',
      browser_bg_dark : '',
      page_bg_light : '',
      page_bg_dark : '',
    },
    share : {
      title : '',
      text : '',
      image_file_id : '',
      image_url : '',
    },
    smtp : {
      from_email : '',
      from_name : '',
      host : '',
      port : '',
      username : '',
      secure : false,
      has_password : false,
      password : '',
    },
    pixel : {
      actif : false,
      mode_test : true,
      pixel_id : '',
      evenement_inscription : true,
      evenement_lancement : true,
      evenement_lead : true,
      consentement_obligatoire : false,
      sans_consentement : false,
      texte_bandeau : '',
      capi_actif : false,
      capi_token : '',
      has_capi_token : false,
      capi_test_event_code : '',
      shopify_actif : false,
      shopify_boutique : '',
      shopify_client_id : '',
      shopify_client_secret : '',
      has_shopify_secret : false,
      texte_optin_shopify : '',
      optin_precoche : false,
      logs_actifs : false,
    },
  }
);

function texte (pValeur, pDefaut = '')
  {
    return typeof pValeur === 'string' ? pValeur : pDefaut;
  }

export function normalise_communication_diffusion_projet (pValeur)
  {
    const tSource = pValeur && typeof pValeur === 'object' ? pValeur : {};
    const tSmtpSource = tSource.smtp && typeof tSource.smtp === 'object' ? tSource.smtp : {};
    const tPixelSource = tSource.pixel && typeof tSource.pixel === 'object' ? tSource.pixel : {};
    const tHeaderSource = tSource.header && typeof tSource.header === 'object' ? tSource.header : {};
    const tShareSource = tSource.share && typeof tSource.share === 'object' ? tSource.share : {};
    const tPort = Number (tSmtpSource.port);
    return {
      editeur_nom : texte (tSource.editeur_nom).trim (),
      logo_file_id : texte (tSource.logo_file_id).trim (),
      logo_url : texte (tSource.logo_url).trim (),
      creation_subject : texte (tSource.creation_subject, COMMUNICATION_DIFFUSION_DEFAUTS.creation_subject).trim ()
        || COMMUNICATION_DIFFUSION_DEFAUTS.creation_subject,
      creation_html : texte (tSource.creation_html, COMMUNICATION_DIFFUSION_DEFAUTS.creation_html),
      reconnexion_subject : texte (tSource.reconnexion_subject, COMMUNICATION_DIFFUSION_DEFAUTS.reconnexion_subject).trim ()
        || COMMUNICATION_DIFFUSION_DEFAUTS.reconnexion_subject,
      reconnexion_html : texte (tSource.reconnexion_html, COMMUNICATION_DIFFUSION_DEFAUTS.reconnexion_html),
      passwordless_sent_html : texte (tSource.passwordless_sent_html, COMMUNICATION_DIFFUSION_DEFAUTS.passwordless_sent_html),
      welcome_html : texte (tSource.welcome_html, COMMUNICATION_DIFFUSION_DEFAUTS.welcome_html),
      header : {
        browser_bg_light : texte (tHeaderSource.browser_bg_light).trim (),
        browser_bg_dark : texte (tHeaderSource.browser_bg_dark).trim (),
        page_bg_light : texte (tHeaderSource.page_bg_light).trim (),
        page_bg_dark : texte (tHeaderSource.page_bg_dark).trim (),
      },
      share : {
        title : texte (tShareSource.title).trim (),
        text : texte (tShareSource.text).trim (),
        image_file_id : texte (tShareSource.image_file_id).trim (),
        image_url : texte (tShareSource.image_url).trim (),
      },
      smtp : {
        from_email : texte (tSmtpSource.from_email).trim (),
        from_name : texte (tSmtpSource.from_name).trim (),
        host : texte (tSmtpSource.host).trim (),
        port : Number.isFinite (tPort) && tPort > 0 ? String (Math.round (tPort)) : '',
        username : texte (tSmtpSource.username).trim (),
        secure : tSmtpSource.secure === true,
        has_password : tSmtpSource.has_password === true,
        password : texte (tSmtpSource.password),
      },
      // Le Pixel ID Meta est purement numérique ; on ne conserve que les chiffres
      // pour neutraliser un copier-coller avec espaces ou libellé.
      pixel : {
        actif : tPixelSource.actif === true,
        // Mode test actif par défaut : un suivi fraîchement configuré ne peut
        // pas atteindre le canal public sans bascule explicite en production.
        mode_test : tPixelSource.mode_test !== false,
        pixel_id : texte (tPixelSource.pixel_id).replace (/\D/g, ''),
        evenement_inscription : tPixelSource.evenement_inscription !== false,
        evenement_lancement : tPixelSource.evenement_lancement !== false,
        evenement_lead : tPixelSource.evenement_lead !== false,
        consentement_obligatoire : tPixelSource.consentement_obligatoire === true,
        // Suivi SANS consentement (séances de test marketing, temporaires) :
        // bandeau masqué, Pixel et envois serveur actifs d'office pour tous les
        // visiteurs. Non conforme au RGPD : chaque période d'activation est
        // consignée par le hub dans un registre visible de tous les admins.
        sans_consentement : tPixelSource.sans_consentement === true,
        texte_bandeau : texte (tPixelSource.texte_bandeau).trim (),
        capi_actif : tPixelSource.capi_actif === true,
        // Les tokens sont transitoires : saisis dans le hub, chiffrés dans
        // pixel_secret à la persistance, jamais stockés en clair dans pixel.
        capi_token : texte (tPixelSource.capi_token).trim (),
        has_capi_token : tPixelSource.has_capi_token === true,
        capi_test_event_code : texte (tPixelSource.capi_test_event_code).trim (),
        shopify_actif : tPixelSource.shopify_actif === true,
        shopify_boutique : texte (tPixelSource.shopify_boutique).trim ()
          .replace (/^https?:\/\//i, '').replace (/\/+$/, ''),
        shopify_client_id : texte (tPixelSource.shopify_client_id).trim (),
        // Secret transitoire (flux client credentials) : chiffré dans
        // pixel_secret à la persistance, comme le token CAPI.
        shopify_client_secret : texte (tPixelSource.shopify_client_secret).trim (),
        has_shopify_secret : tPixelSource.has_shopify_secret === true,
        texte_optin_shopify : texte (tPixelSource.texte_optin_shopify).trim (),
        // Pré-cochage de la case d'opt-in : désactivé par défaut, un
        // consentement pré-coché étant contestable (CNIL / CJUE Planet49).
        optin_precoche : tPixelSource.optin_precoche === true,
        // Récolte du journal des échanges serveur par le hub (sondage rapide,
        // à n'activer que sur des tranches de temps limitées).
        logs_actifs : tPixelSource.logs_actifs === true,
      },
      smtp_secret : tSource.smtp_secret && typeof tSource.smtp_secret === 'object'
        ? tSource.smtp_secret
        : null,
      pixel_secret : tSource.pixel_secret && typeof tSource.pixel_secret === 'object'
        ? tSource.pixel_secret
        : null,
    };
  }
